export default __webpack_public_path__ + "static/media/react-router.a87b7227.svg";